<template>
  <h1>Report an Error</h1>
</template>

<script>
export default {

}
</script>

<style>

</style>